export function getCurrentUrl() {
  return self.location.href;
}

export function getCurrentQueryParams() {
  return self.location.search;
}
